import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import Modal from "@mui/material/Modal";
import {Button, MenuItem, Select, Stack, TextField} from "@mui/material";
import Box from "@mui/material/Box";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "320px",
  maxWidth: "sm", width: "90%",
  maxHeight: "80vh",
  bgcolor: 'background.paper',
  borderRadius: 0,
  border: '0px solid #000',
  boxShadow: 24,
  p: 3,
  overflowY: "auto"
};

const initState = {
  name: "",
  description: "",
  type: ""
}

export const CreateToolParameter = ({
                                      open, handleClose, selectedParameter,
                                      tool, setTool
                                    }) => {
  const [parameter, setParameter] = useState({...initState});

  useEffect(() => {
    if (selectedParameter && tool?.function) {
      setParameter(
        {...(tool?.function?.parameters?.properties[selectedParameter] || initState), name: selectedParameter}
      );
    }
  }, [selectedParameter, tool]);

  const onSave = () => {
    const data = {...tool};
    if (!parameter.name) {
      return;
    }
    if (selectedParameter) {
      delete data.function.parameters.properties[selectedParameter];

    }
    data.function.parameters.properties[parameter.name] = {type: parameter.type, description: parameter.description};
    if (selectedParameter && data.function.parameters.required?.includes(selectedParameter)) {
      data.function.parameters.required = data.function.parameters.required?.filter(i => i !== selectedParameter);
      data.function.parameters.required.push(parameter.name);
    }
    setTool(data);
    handleClose();
  }

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={2} sx={style}>
        <Typography variant={"h4"} fontWeight={"bold"}
                    sx={{mb: 1}}>{selectedParameter ? "Update" : "Create"} Parameter</Typography>
        <Box>
          <Typography fontWeight={600} gutterBottom>Name:</Typography>
          <TextField
            size={"small"} placeholder={"Enter name of the parameter"}
            helperText={"Name should be unique"}
            value={parameter?.name} autoFocus fullWidth
            onChange={e => setParameter(prev => ({
              ...prev,
              name: e?.target?.value?.replaceAll(" ", "_")?.toLowerCase()
            }))}
          />
        </Box>
        <Box>
          <Typography fontWeight={600} gutterBottom>Type:</Typography>
          <Select
            value={parameter?.type} fullWidth size={"small"}
            onChange={e => setParameter(prev => ({
              ...prev,
              type: e?.target?.value
            }))}
          >
            <MenuItem value={"int"}>int</MenuItem>
            <MenuItem value={"string"}>string</MenuItem>
            <MenuItem value={"float"}>float</MenuItem>
          </Select>
        </Box>
        <Box>
          <Typography fontWeight={600} gutterBottom>Description:</Typography>
          <TextField
            size={"small"} placeholder={"Describe parameter"}
            multiline rows={3}
            value={parameter?.description} fullWidth
            onChange={e => setParameter(prev => ({
              ...prev,
              description: e?.target?.value
            }))}
          />
        </Box>

        <Stack direction={'row'} gap={1} useFlexGap flexWrap={"wrap"}>
          <Button
            variant={"contained"}
            color={"secondary"}
            sx={{borderRadius: 0, textTransform: "capitalize"}}
            disabled={!parameter?.name}
            onClick={onSave}
          >
            Save
          </Button>
          <Button
            variant={"outlined"}
            color={"secondary"}
            sx={{borderRadius: 0, textTransform: "capitalize"}}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Modal>
  )
}